<fgb-account-layout titleKey="account.partners.title" titleDefault="Partners">
  <fgb-account-panel titleKey="account.partners.title" titleDefault="Partners">
    <div *ngIf="partnerLimit$ | async as partnerLimit" class="partners-panel">
      <p class="partners-description" [innerHTML]="'partner.page.info.text' | translate | markdownTranslate"></p>

      <div class="partners-actions">
        <button
          type="button"
          class="btn-filled-primary"
          [disabled]="currentPartnerCount >= partnerLimit"
          (click)="openAddForm()"
          aria-label="Invite partner"
        >
          {{ 'account.partners.invite' | translate : { fgbdefault: 'Invite Partner' } }}
        </button>
        <button
          type="button"
          class="btn-outline-success"
          [disabled]="currentPartnerCount >= partnerLimit"
          (click)="openAcceptForm()"
          aria-label="Accept partner"
        >
          {{ 'account.partners.accept' | translate : { fgbdefault: 'Accept Partner' } }}
        </button>
      </div>

      <fgb-partner-list [partnerLimit]="partnerLimit"></fgb-partner-list>
    </div>
  </fgb-account-panel>
</fgb-account-layout>
